import Vue from 'vue'
import Router from 'vue-router'
//二维码

import supplierList from '@/components/supplier-list'
import checkLogin from '@/components/check-login'
import msoIndex from '@/components/mso-index'
import msoList from '@/components/mso-list'
import checkInfo from '@/components/check-info'
import login from '@/components/login'
import supplierIndex from '@/components/supplier-index'
import supplierContract from '@/components/supplier-contract'
import supplierOrder from '@/components/supplier-order'
import supplierQr from '@/components/supplier-qr'
import supplierInfo from '@/components/supplier-info'
import supplierEdit from '@/components/supplier-edit'
import supplierAdd from '@/components/supplier-add'
import supplierMyContract from '@/components/supplier-mycontract'
import supplierMyApprove from '@/components/supplier-approve'
import supplierPsw from '@/components/supplier-psw'
import msoSign from '@/components/mso-sign'
import updateGrant from '@/components/update-grant'
import forgotPassword from "@/components/forgot-password";
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'login',
      component: login,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierAdd',
      name: 'supplierAdd',
      component: supplierAdd,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierPsw',
      name: 'supplierPsw',
      component: supplierPsw,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierMyContract',
      name: 'supplierMyContract',
      component: supplierMyContract,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierMyApprove',
      name: 'supplierMyApprove',
      component: supplierMyApprove,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierList',
      name: 'supplierList',
      component: supplierList,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierInfo',
      name: 'supplierInfo',
      component: supplierInfo,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierEdit',
      name: 'supplierEdit',
      component: supplierEdit,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: forgotPassword,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/msoIndex',
      name: 'msoIndex',
      component: msoIndex,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
		{
		    path: '/checkLogin',
		    name: 'checkLogin',
		    component: checkLogin,
		    meta: {
		      keepAlive: false // 需要被缓存
		    }
		  },
    {
      path: '/checkInfo',
      name: 'checkInfo',
      component: checkInfo,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/msoList',
      name: 'msoList',
      component: msoList,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierIndex',
      name: 'supplierIndex',
      component: supplierIndex,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierContract',
      name: 'supplierContract',
      component: supplierContract,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierOrder',
      name: 'supplierOrder',
      component: supplierOrder,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/supplierQr',
      name: 'supplierQr',
      component: supplierQr,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/msoSign',
      name: 'msoSign',
      component: msoSign,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
    {
      path: '/updateGrant',
      name: 'updateGrant',
      component: updateGrant,
      meta: {
        keepAlive: false // 需要被缓存
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js